import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'simple-paginator',
  templateUrl: './simple-paginator.component.html',
  styleUrls: ['./simple-paginator.component.scss']
})
export class SimplePaginatorComponent {

  @Input()
  pageNumber: number;

  @Input()
  pageCount: number;

  @Output()
  clickFirst = new EventEmitter<any>();

  @Output()
  clickNext = new EventEmitter<any>();

  get isFirstPage(): boolean {
    return this.pageNumber === 1;
  }

  get isEndOfSet(): boolean {
    return this.pageCount === this.pageNumber;
  }

  onClickFirstPage() {
    this.clickFirst.emit();
  }

  onClickNext() {
    this.clickNext.emit();
  }
}
